import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  DataService,
  FormInputComponent,
  RelationCustomFieldConfig,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import { ActivatedRoute } from "@angular/router";
import {
  FetchListCountryBaseShippingFeeDocument,
  FetchListCountryBaseShippingFeeQuery,
  GetZonesDocument,
  SortOrder,
} from "src/generated-gql/graphql";
import {
  Observable,
  switchMap,
  Subject,
  concat,
  debounceTime,
  of,
  tap,
  distinctUntilChanged,
  catchError,
} from "rxjs";

@Component({
  standalone: true,
  imports: [SharedModule],
  selector: "default-country-base-shipping-fee-selector",
  templateUrl: "./default-plan-selector.component.html",
})
export class DefaultPlanSelectorComponent
  implements OnInit, FormInputComponent<RelationCustomFieldConfig>
{
  readonly: boolean;
  formControl: FormControl;
  config: RelationCustomFieldConfig;
  constructor(
    protected dataService: DataService,
    private route: ActivatedRoute
  ) {}
  shippingFeePlan$: Observable<
    FetchListCountryBaseShippingFeeQuery["countryBaseShippingFees"]["items"]
  >;
  ngOnInit(): void {
    console.log("Item", this.formControl.value)
    this.shippingFeePlan$ = concat(
      this.dataService
        .query(FetchListCountryBaseShippingFeeDocument, {
          options: {
            take: 5,
            sort: {
              createdAt: SortOrder.Desc,
            },
          },
        })
        .single$.pipe(
          switchMap((data) => of(data.countryBaseShippingFees.items))
        ),
      this.input$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => (this.isLoading = true)),
        switchMap((term) =>
          this.dataService
            .query(FetchListCountryBaseShippingFeeDocument, {
              options: {
                take: 5,
                skip: 0,
                filter:
                  term && term.length > 0
                    ? {
                        name: {
                          contains: term,
                        },
                      }
                    : undefined,
              },
            })
            .mapStream(
              ({ countryBaseShippingFees }) => countryBaseShippingFees.items
            )
            .pipe(
              catchError(() => of([])),
              tap(() => (this.isLoading = false))
            )
        )
      )
    );

    this.formControl.valueChanges.subscribe((value) => {
      console.log("value", value);
    });
  }

  isLoading = false;
  trackByFn(item: { id: any }) {
    return item.id;
  }

  compareFn(item1: { id: string } | null, item2: { id: string } | null) {
    return item1 && item2 ? item1.id === item2.id : item1 === item2;
  }

  input$ = new Subject<string>();
}
